import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../../utils/cn'

export type CardVariant = 'filled' | 'outlined' | 'tonal'

/* Zero shadow anywhere: the design system defines depth as a tonal step plus a
   hairline, so hover only changes the fill and the border. */
const VARIANTS: Record<CardVariant, string> = {
  filled: 'bg-surface-container-lowest border border-outline-variant/30',
  outlined: 'bg-transparent border border-primary/10',
  tonal: 'bg-surface-container-low border border-primary/5',
}

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant
  /** Adds the Stitch hover treatment; use on cards that are themselves a target. */
  interactive?: boolean
  padded?: boolean
  children: ReactNode
}

export function Card({
  variant = 'filled',
  interactive = false,
  padded = true,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      {...rest}
      className={cn(
        'rounded-xl transition-colors duration-300',
        VARIANTS[variant],
        padded && 'p-6 md:p-8',
        interactive && 'cursor-pointer hover:border-primary/20 hover:bg-surface-container-low',
        className,
      )}
    >
      {children}
    </div>
  )
}
